import type { ImageModelCaches } from '@/components/ui/carousel/carousel.types';

/**
 * The card-sized thumbnail for an asset's cache map: the 300w derivative,
 * falling back to 830w.
 *
 * `||`, not `??`, deliberately. Cache keys are written per-derivative and an
 * asset can arrive with an EMPTY-STRING entry; `??` keeps that empty string,
 * which then paints the broken-image glyph (or gets dropped downstream as
 * falsy, e.g. DeleteConfirmDialog's thumb strip) instead of falling through to
 * the next size. A missing thumbnail is `undefined`, never `''`, so callers can
 * branch on one thing.
 *
 * Not yet the single home of this rule: `AssetsImageCard`, `StagingModal`,
 * `OrderServiceModal` and `ui/carousel/thumbnail-slider.tsx` all still inline
 * the same expression and remain to be migrated — untouched adjacent code, out
 * of scope for DV-2524. That list is exhaustive as of this commit; keep it so,
 * because a partial consumer list is how one of these silently drifts.
 */
export function pickThumbnailUrl(
  caches: ImageModelCaches | null | undefined
): string | undefined {
  return caches?.['300w'] || caches?.['830w'] || undefined;
}
